module.exports = __webpack_public_path__ + "images/emoji/arrow_upper_right.fc97c3df06f02fed3e5f.png";